import { Component, Input, Output, EventEmitter } from "@angular/core";
import { AutoMapperService } from "../../../services/Common/auto-mapper.service";
import { AlertService } from "../../../services";
import { Subscription } from "rxjs/Subscription";
import { DashboardComponent } from "../dashboard-component";
import { HttpClient, HttpParams} from "@angular/common/http";
import { Provinces } from '../../provinces/provinces';
import { LocationGroup } from '../../location-group/location-group';

@Component({
    template: require('./line-graph.html'),
    selector: 'line-graph'
})

export class LineGraphComponent implements DashboardComponent {

    public labels: Array<string>;
    public chartData: Array<any> = null;
    public subscription: Subscription = null;
    @Input() public header: string = '';
    @Input() public subHeader: string = '';
    @Input() public url: string;
    @Output() refreshed = new EventEmitter();

    constructor(
        private http: HttpClient,
        private autoMapperService: AutoMapperService,
        private alertService: AlertService
    ) {
    }

    public update(): void {
        let self: LineGraphComponent = this;
        this.subscription = this.http.get<any>(this.url)
            .subscribe(result => {
                if((result.Labels && result.Labels.length > 0) && (result.DataSet && result.DataSet.length > 0)){
                    self.labels = result.Labels;
                    self.chartData = result.DataSet;
                }
                self.refreshed.next();
            }, error => self.refreshed.next());
    }

    public updateDashboard(provinces: any, locationGroup:any): void {
        let self: LineGraphComponent = this;
     
        this.subscription = this.http.post<any>(this.url,{
            provinces: provinces,
            locationGroup: locationGroup
        }).subscribe(result => {
                if((result.Labels && result.Labels.length > 0) && (result.DataSet && result.DataSet.length > 0)){
                    self.labels = result.Labels;
                    self.chartData = result.DataSet;
                }
                self.refreshed.next();
            }, error => self.refreshed.next());
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/dashboards/line-graph/line-graph.component.ts